import axios from '@/axios';
import moment from '@/utils/moment';

export default {
	namespaced: true,

	actions: {
		async getEmployeeRecords(_, { id }) {
			return axios.get('/PersonalAction/Employee/' + id).then(({ data }) => data);
		},
		async addRecord(_, { employeeId, date, idFrom, idTo, personalAction, description }) {
			return axios
				.post('/PersonalAction/Perform', {
					employeeId,
					date: moment(date).format(),
					description: description || '-',
					idFrom,
					idTo,
					personalAction,
				})
				.then(({ data }) => data);
		},
	},
};
